import { render, staticRenderFns } from "./custodia-historias.vue?vue&type=template&id=e26cff46&scoped=true&"
import script from "./custodia-historias.vue?vue&type=script&lang=js&"
export * from "./custodia-historias.vue?vue&type=script&lang=js&"
import style0 from "./custodia-historias.vue?vue&type=style&index=0&id=e26cff46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e26cff46",
  null
  
)

export default component.exports